<!-- Footer -->
<section class="flex flex-col bg-white justify-center w-full">
    <!-- Footer Section -->
    <footer class="relative pt-8 pb-8">

        <div
            class="max-w-7xl mx-auto px-5 pb-5 grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-10 relative z-10">
            <!-- About -->
            <div class="flex flex-col items-center text-center space-y-6">
                @if(view.site) {
                <div class="flex items-center h-16 px-2">
                    <img class="w-72" [src]="view.site?.logoUrl" alt="Logo image">
                </div>
                }
                @if(view.site?.slogan) {
                <p class="mb-4 leading-relaxed font-semibold text-primary-500 text-center text-xl opacity-90">
                    {{view.site?.slogan}}
                </p>
                }
                <!-- Social Links -->
                <div class="flex space-x-3">
                    @if(view.site?.socialUrlFacebook) {
                    <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                        class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                            [svgIcon]="'feather:facebook'"></mat-icon>
                    </a>
                    }
                    @if(view.site?.socialUrlInstagram) {
                    <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                        class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                            [svgIcon]="'feather:instagram'"></mat-icon>
                    </a>
                    }
                    @if(view.site?.socialUrlTwitter) {
                    <a href="{{view.site?.socialUrlTwitter}}" target="_blank"
                        class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                            [svgIcon]="'feather:twitter'"></mat-icon>
                    </a>
                    }
                    @if(view.site?.socialUrlLinkedIn) {
                    <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                        class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                            [svgIcon]="'feather:linkedin'"></mat-icon>
                    </a>
                    }
                    @if(view.site?.socialUrlYouTube) {
                    <a href="{{view.site?.socialUrlYouTube}}" target="_blank"
                        class="group relative w-8 h-8 ml-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                        <img src="/assets/icons/xlgo-1.png" alt="">
                    </a>
                    }
                </div>
            </div>

            <!-- Quick Links -->
            <div>
                <h3 class="text-xl text-accent-500 mb-6 border-b-2 border-accent-500 pb-2">Quick Links</h3>
                <ul class="space-y-3">
                    <!-- <li><a href="#"
                            class="flex items-center gap-2 opacity-90 hover:opacity-100 hover:translate-x-1 transition-all duration-300">Home</a>
                    </li>
                    <li><a href="#"
                            class="flex items-center gap-2 opacity-90 hover:opacity-100 hover:translate-x-1 transition-all duration-300">About Us</a>
                    </li>
                    <li><a href="#"
                            class="flex items-center gap-2 opacity-90 hover:opacity-100 hover:translate-x-1 transition-all duration-300">Services</a>
                    </li> -->
                    <li>
                        <button class="flex items-center gap-2">
                            Destinations
                        </button>
            
                        <ul class="mt-2 pl-6 space-y-2 text-sm text-gray-700">
                            @for(destination of limitedDestinations(); track destination) {
                            <li>
                                <a href="#" class="hover:text-accent-500 hover:translate-x-1 transition-all duration-300">{{ destination.name }}</a>
                            </li>
                            }
            
                            @if(hasMoreDestinations()) {
                            <li class="pt-2">
                                <button (click)="view.showAllDestinations = !view.showAllDestinations"
                                    class="text-accent-500 hover:underline text-sm flex items-center gap-2">
                                    @if(!view.showAllDestinations){
                                    <mat-icon class="icon-size-5 text-gray-500 opacity-90"
                                        svgIcon="feather:chevron-down"></mat-icon>
                                    }
                                    @if(view.showAllDestinations){
                                    <mat-icon class="icon-size-5 text-gray-500 opacity-90" svgIcon="feather:chevron-up"></mat-icon>
                                    }
                                    {{ view.showAllDestinations ? 'View Less' : 'View More' }}
                                </button>
                            </li>
                            }
                        </ul>
                    </li>
                </ul>
            </div>

            <!-- Contact Us -->
            <div>
                <h3 class="text-xl text-accent-500 mb-6 border-b-2 border-accent-500 pb-2">Contact Us</h3>
                <ul class="space-y-4 mb-6">
                    @if(view.site?.address){
                    <li class="flex items-start gap-4">
                        <mat-icon class="icon-size-5 text-primary-500" [svgIcon]="'mat_solid:location_on'"></mat-icon>
                        <div class="tracking-wide">
                            {{view.site?.address}}
                        </div>
                    </li>
                    }
                    @if(view.site?.telephone){
                    <li class="flex items-start gap-4">
                        <mat-icon class="icon-size-5 text-primary-500" [svgIcon]="'mat_solid:local_phone'"></mat-icon>
                        <div>
                            <p class="block opacity-90 hover:opacity-100">{{view.site?.telephone}}</p>
                        </div>
                    </li>
                    }
                    @if(view.site?.emailAddress){
                    <li class="flex items-start gap-4">
                        <mat-icon class="icon-size-5 text-primary-500" [svgIcon]="'mat_solid:email'"></mat-icon>
                        <div>
                            <a [href]="'mailto:' + view.site?.emailAddress"
                                class="block tracking-wide hover:underline opacity-90 hover:opacity-100">{{view.site?.emailAddress}}</a>
                        </div>
                    </li>
                    }
                </ul>


            </div>

            <!-- Newsletter & Image section -->
            <div>
                <!-- Newsletter -->
                <div>
                    <h3 class="text-xl text-accent-500 mb-2 border-b-2 border-accent-500 pb-2">Newsletter</h3>
                    <p class="mb-4 opacity-70">Subscribe to get updates on our latest events and offers.</p>
                    <form class="flex">
                        <input type="email" placeholder="Your Email" required
                            class="flex-1 p-3 rounded-l-md focus:outline-none border-l-2 border-t-2 border-b-2 border-accent-500" />
                        <button type="submit"
                            class="bg-accent-500 hover:bg-accent-800 text-white p-3 rounded-r-md transition">
                            <mat-icon class="text-white icon-size-5" svgIcon="feather:send"></mat-icon>
                        </button>
                    </form>
                </div>
                <div class="mt-5">
                    <img src="/assets/images/xl-travel/XLFS LOGO.jpg?=v2" alt="flight specials logo">
                </div>
            </div>
        </div>

        <!-- Copyright -->
        <div class="w-full py-7 border-t">
            <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row px-15">
                <p class="text-sm text-center text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}} <span
                        class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.</p>

                @if(view.pages) {
                <ul class="flex items-center gap-9 mt-4 lg:mt-0">
                    @for(page of view.pages; track page) {
                    <li><a [routerLink]="['/policy', page.seo.alias]"
                            class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a></li>
                    }

                    @if(view.site?.id === 99) {
                    <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/sandown-booking-form.pdf'"
                            target="_blank"
                            class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Download
                            Booking Form</a></li>
                    <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/sandown-terms-conditions.pdf'"
                            target="_blank"
                            class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Terms &
                            Conditions</a></li>
                    }
                </ul>
                }
            </div>
        </div>
    </footer>

</section>